module.exports = __webpack_public_path__ + "img/public/SiteIcons/noReviewIcon.svg?f2c83f1d";